module.exports = __webpack_public_path__ + "img/item15.6cdbfda3.png";